export default __webpack_public_path__ + "locales/ja-JP/DeleteDialog.json?hash=3967fe397ca05c5c5bb807e405863abb";